//TODO LINT
/* eslint-disable */

export const getDriverState = ({ driver }) => driver

export const getDriversOptimiserIsLoading = (state) =>
  getDriverState(state).isLoadingDriversOptimiser

export const getDriversOptimiser = (state) =>
  getDriverState(state).driversOptimiser.map(
    ({
      firstname,
      lastname,
      phone,
      vehiculeId,
      id,
      adresseDepart,
      adresseArrivee,
      operationalHours,
      prestation,
    }) => {
      const vehicule = vehiculeId?.id
        ? vehiculeId
        : { vehicule_category: { volumeMax: 20, weight: 2000 } }
      return {
        firstname,
        lastname,
        phone,
        vehiculeId: vehicule,
        id,
        checked: false,
        adresseDepart,
        adresseArrivee,
        operationalHours,
        prestation,
      }
    }
  )

export const getDrivers = (state) => getDriverState(state).drivers

export const getDriversOptimiserCount = (state) =>
  getDriverState(state).driversOptimiserCount
